import PropTypes from 'prop-types';
import { createContext, useContext, useMemo } from 'react';
import useWebhookActivities, {
  WEBHOOK_ACTIVITY_DEFAULT_FILTER,
  WEBHOOK_ACTIVITY_SCOPES,
} from '@/hooks/useWebhookActivities';
import { WebhooksContext } from '@/contexts/WebhooksContext';

export const WebhookActivityStatus = {
  success: {
    label: 'Sucesso',
    value: 'success',
    color: 'success',
  },
  warning: {
    label: 'Em processamento',
    value: 'warning',
    color: 'warning',
  },
  error: {
    label: 'Erro',
    value: 'error',
    color: 'error',
  },
};

export const WebhookActivityDefaultFilter = WEBHOOK_ACTIVITY_DEFAULT_FILTER;
export const WebhookActivityScopes = WEBHOOK_ACTIVITY_SCOPES;

export const WebhookActivityContext = createContext({
  table: {},
  activities: { results: [], count: 0 },
  previewActivities: [],
  eventOptions: [],
  fetching: false,
  refetchActivities: () => {},
  usesPagination: false,
});

export default function WebhookActivityProvider({
  children,
  scope = WEBHOOK_ACTIVITY_SCOPES.FULL,
}) {
  const { rawWebhooks } = useContext(WebhooksContext);
  const webhookActivities = useWebhookActivities({
    webhooks: rawWebhooks,
    scope,
  });

  const value = useMemo(() => webhookActivities, [webhookActivities]);

  return (
    <WebhookActivityContext.Provider value={value}>
      {children}
    </WebhookActivityContext.Provider>
  );
}

WebhookActivityProvider.propTypes = {
  children: PropTypes.node.isRequired,
  scope: PropTypes.oneOf(Object.values(WEBHOOK_ACTIVITY_SCOPES)),
};
